
import {Component, Vue} from 'vue-property-decorator';
import {readUserProfileStats} from '@/store/main/getters';
import {dispatchGetUserProfileStats} from "@/store/main/actions";

@Component({})
export default class Stats extends Vue {
  private get userStats() {
    return readUserProfileStats(this.$store)?.summarized
  }

  private getClassColor(item) {
    const alertClasses = ['total_external_users_unregistered', 'total_form_batch_pending'];
    const successClasses = ['total_active_users'];
    const inactiveClasses = ['total_inactive_users'];
    if (successClasses.find((e) => e === item)) {
      return 'success';
    } else if (alertClasses.find((e) => e === item)) {
      return 'error';
    } else if (inactiveClasses.find((e) => e === item)) {
      return 'grey';
    }
    return 'primary';
  }

  public mounted() {
    dispatchGetUserProfileStats(this.$store)
  }

}
